import { ThemeColor } from './themes/types'

const darkColors: ThemeColor[] = ['black', 'greyLight', 'primary', 'primaryDark', 'transparent']

export const getTextColorFromBackgroundColor = (
  backgroundColor: ThemeColor,
  subtle = false,
): ThemeColor => {
  if (subtle) {
    return 'textSubtle'
  }

  return darkColors.includes(backgroundColor) ? 'textInverted' : 'text'
}
